module.exports = __webpack_public_path__ + "static/ubicaciones-1f9483f2bae7388139007ad942d8e417.svg";